const stringExtents = () => {
  String.prototype.trim = function() {
    return this.replace(/^\s+|\s+$/g, '')
  }

  String.prototype.toCamel = function() {
    // eslint-disable-next-line no-useless-escape
    return this.replace(/(\-[a-z])/g, function($1) {
      return $1.toUpperCase().replace('-', '')
    })
  }

  String.prototype.toDash = function() {
    return this.replace(/(?:^|\.?)([A-Z])/g, function($1) {
      return '-' + $1.toLowerCase()
    }).replace(/^-/, '')
  }

  String.prototype.toUnderscore = function() {
    return this.replace(/(?:^|\.?)([A-Z])/g, function($1) {
      return '_' + $1.toLowerCase()
    }).replace(/^_/, '')
  }

  String.prototype.truncate =
    String.prototype.truncate ||
    function(n, useWordBoundary) {
      if (this.length <= n) {
        return this
      }
      const subString = this.substr(0, n - 1) // the original check
      return (
        (useWordBoundary
          ? subString.substr(0, subString.lastIndexOf(' '))
          : subString) + '...'
      )
    }
}

export default stringExtents
